const globalCallback = function(){
  console.log( "JS READY!" );
  
  const megaMenu = document.querySelector('.header__menu');
  
  const dynamicSections = document.querySelector('.dynamic-sections');
  
  const attachListeners = function(){
    
    megaMenu.querySelectorAll('.tmenu_item_level_0').forEach(item => {
      
      if(item.classList.contains('tmenu_item_has_child')){

        item.addEventListener('mouseenter', function(){

          dynamicSections.classList.add('overlay-visible');
        });

        item.addEventListener('mouseleave', function(){

          dynamicSections.classList.remove('overlay-visible');
        });
      }
    });
  };
  
  const config = { attributes: true, childList: true, subtree: true };

  const callback = function(mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for(const mutation of mutationsList) {
          if (mutation.type === 'childList') {

            attachListeners();

            observer.disconnect();
            
            break;
          }
      }
  };

const observer = new MutationObserver(callback);

observer.observe(megaMenu, config);

//observer.disconnect();
};

let desktopLayout = window.matchMedia('(min-width: 799px)');
      
if(desktopLayout.matches){
  if (document.readyState === "complete" || document.readyState === "interactive") {
	setTimeout(globalCallback, 1);
  } else {
    document.addEventListener("DOMContentLoaded", globalCallback);
  }
}